import { contentBlockSurface } from 'shared/assets/styles';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: ${({ theme }) =>
    theme.isMobile ? `calc(100dvh - 6.4rem)` : '100dvh'};
  width: 100%;
  // padding-right: ${({ theme }) => theme.spacing(0.5)};
`;

export const Main = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)}`};
  min-width: 0;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${contentBlockSurface};
  overflow: hidden;
`;

export const SidePanel = styled.div<{ $open: boolean }>`
  height: 100%;

  ${({ theme, $open }) =>
    $open &&
    css`
      padding: ${`${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} 0`};
    `};
`;

export const SidePanelContent = styled.div<{ $open: boolean }>`
  height: 100%;
  overflow: hidden;

  ${({ $open }) =>
    $open &&
    css`
      ${contentBlockSurface};
    `};
`;
